module.exports = __webpack_public_path__ + "static/img/connect-img-right.a2cb9ef6.png";